export default "__VITE_ASSET__B$E69xUH__"